import React, { useState } from 'react';
import classNames from 'classnames';

import ChevronDown from '@/icons/ChevronDown';
import { type AccordionItem, type AccordionProps } from './Accordion.types';
import { AnimatePresence, motion } from 'framer-motion';

const AccordionChild: React.FC<{ item: AccordionItem; iconColor: string }> = ({
  item,
  iconColor,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (item: AccordionItem) => {
    setIsOpen(!isOpen);

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'component_interaction',
        component_type: 'accordion - header',
        component_name: 'accordion',
        interaction_type: (isOpen ? 'close' : 'open') + ' accordion',
        interaction_value: item.title,
      });
    }
  };

  return (
    <div
      className={classNames('accordion__item', {
        'accordion__item--open': isOpen,
      })}
    >
      <button
        className="accordion__item-heading"
        onClick={() => handleClick(item)}
        title={isOpen ? `Close ${item.title}` : `Open ${item.title}`}
      >
        <div className="accordion__title">{item.title}</div>
        <ChevronDown className="accordion__item-chevron" fill={iconColor} />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <div
              className="accordion__content"
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const Accordion: React.FC<AccordionProps> = ({ items, iconColor }) => {
  return (
    <div className="accordion">
      {items &&
        items.map((item) => (
          <AccordionChild iconColor={iconColor} item={item} key={item.id} />
        ))}
    </div>
  );
};

export default Accordion;
